













































































































































































































import { Component, Prop, Mixins, Inject, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import _ from "@/boot/lodash";
import Context from "@/mixins/context";
import { IInvoice } from "@/models/invoices";
import { IContract } from "@/models/contracts";
import {
  IInvoicesProvider,
  IInvoicesProviderMethods
} from "@/models/providers/invoice";

@Component({
  components: {
    "relative-invoice-status": () =>
      import("@/components/app/global/invoices/relativeInvoiceStatus.vue"),
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class InvoicesTableView extends Mixins(Context) {
  // Inject

  @Inject({ from: "invoicesProvider" })
  public invoicesProvider!: () => IInvoicesProvider;

  @Inject({ from: "invoicesProviderMethods" })
  public $invoicesMethods!: IInvoicesProviderMethods;

  // Props

  @Prop({ default: false })
  public isPaginated!: IContract["id"];

  @Prop({ default: "u-invoice-link" })
  public rowTag!: string;

  @Prop({
    default: () => (invoice: IInvoice) => ({
      invoiceId: invoice.id,
      clientId: invoice.client_id
    })
  })
  public rowProps!: (invoice: IInvoice) => Record<string, any>;

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (invoice: IInvoice) => { [key: string]: Function };

  @Prop({ default: false })
  public isSelectable!: boolean;

  @Prop({ default: () => [] })
  public selectedIds!: IInvoice["id"][];

  // Data

  public isMultibrand!: boolean;

  public loading = true;
  public filter = "";

  public selectedInvoiceIds: IInvoice["id"][] = [];
  public allSelectedInvoiceIds = false;

  // Computed

  public get $invoicesData() {
    return this.invoicesProvider();
  }

  public get table() {
    return this.$invoicesData.table;
  }

  public get guardFunctionalities() {
    return this.$invoicesData.guardFunctionalities;
  }

  public get isLoading() {
    return this.$invoicesData.isLoading;
  }

  public get isReloading() {
    return this.$invoicesData.isReloading;
  }

  public get clientId() {
    return this.$invoicesData.clientId;
  }

  public selectAllInvoiceIds(value) {
    this.selectedInvoiceIds = value
      ? this.$_.map(this.allAvailableInvoices, invoice => invoice.id)
      : [];
    this.$emit("updateSelectedIds", this.selectedInvoiceIds);
  }

  public get allAvailableInvoices() {
    return _.filter(_.cloneDeep(this.table.data), invoice => {
      return _.isEmpty(invoice.affiliate_commissions);
    });
  }

  @Watch("selectedIds")
  public onSelectedIdsChange() {
    this.$set(this, "selectedInvoiceIds", this.selectedIds);
    this.$set(
      this,
      "allSelectedInvoiceIds",
      this.selectedInvoiceIds.length > 0 &&
        this.allAvailableInvoices.length > 0 &&
        this.selectedInvoiceIds.length === this.allAvailableInvoices.length
    );
  }
}
